import { FC, HTMLAttributes } from 'react'
import cn from 'classnames'

export const BookingContainer: FC<HTMLAttributes<HTMLDivElement>> = ({ children, className }) => (
  <div data-testid="booking-container" className="bg-base-lightest min-h-full">
    <div className={cn('mx-auto flex w-full max-w-screen-xl flex-col px-4 sm:px-6 xl:px-0', className)}>{children}</div>
  </div>
)
